import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
// style
import { createStyles, makeStyles, styled, alpha } from "@material-ui/styles";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const basicRootProps = {
  "& fieldset": {
    borderColor: "#e6e9ef",
  },
  "&:hover fieldset": {
    borderColor: "#e6e9ef",
  },
  "&.Mui-error fieldset": {
    borderColor: "#ff5252",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#3bbff0",
  },
};

const basicRootPropsError = {
  "& fieldset": {
    borderColor: "#ff5252",
  },
  "&:hover fieldset": {
    borderColor: "#ff5252",
  },
  "&.Mui-error fieldset": {
    borderColor: "#ff5252",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#ff5252",
  },
};

const basicInputProps = {
  borderRadius: 4,
  position: "relative",
  fontSize: 14,
  width: "auto",
  height: "32px",
  padding: "9px 16px",
};

const getBasicRootProps = (error) => {
  if (error) {
    return basicRootPropsError;
  }
  return basicRootProps;
};

const StyledInputNormal = styled(OutlinedInput)(({ theme, error }) => ({
  "&.MuiOutlinedInput-root": {
    height: "36px",
    ...getBasicRootProps(error),
  },
  "& .MuiOutlinedInput-input": {
    ...basicInputProps,
    fontSize: 14,
  },
}));

const StyledInputSmall = styled(OutlinedInput)(({ theme, error }) => ({
  "&.MuiOutlinedInput-root": {
    height: "33px",
    ...getBasicRootProps(error),
    "& .MuiOutlinedInput-input": {
      ...basicInputProps,
      fontSize: 12,
    },
  },
}));

const StyledInputLarge = styled(OutlinedInput)(({ theme, error }) => ({
  "&.MuiOutlinedInput-root": {
    height: "40px",
    ...getBasicRootProps(error),
  },
  "& .MuiOutlinedInput-input": {
    ...basicInputProps,
    fontSize: 14,
  },
}));
//
const InputBasic = ({ label, size, ...rest }) => {
  // style
  const classes = useStyles();
  // props

  const getCustomInput = () => {
    let CustomInput;
    switch (size) {
      case "normal":
        CustomInput = StyledInputNormal;
        break;
      case "small":
        CustomInput = StyledInputSmall;
        break;
      case "large":
        CustomInput = StyledInputLarge;
        break;
      default:
        CustomInput = StyledInputNormal;
    }
    return <CustomInput {...rest} />;
  };

  return (
    <Box>
      {label && <InputLabel>{label}</InputLabel>}
      {getCustomInput()}
    </Box>
  );
};

InputBasic.propTypes = {
  label: PropTypes.string,
  size: PropTypes.oneOf(["normal", "small", "large"]),
};

InputBasic.defaultProps = {
  label: null,
  size: "normal",
};

export default InputBasic;
